<template>
     <v-navigation-drawer
          bottom
          color="transparent"
          fixed
          height="auto"
          overlay-color="secondary"
          overlay-opacity=".8"
          temporary
          v-bind="$attrs"
          v-on="$listeners"
     >
          <v-list color="white" shaped>
               <div v-for="(menu, index) in items" :key="index">
                    <v-list-item
                         :to="menu.route"
                         :exact="menu.name === 'Home'"
                         color="primary"
                    >
                         <v-list-item-content>
                              <v-list-item-title v-text="menu.name" />
                              <v-list-item
                                   v-for="(sub, index2) in menu.subPages"
                                   :key="index2"
                                   :to="sub.route"
                                   :exact="sub.name === 'Home'"
                                   color="primary"
                              >
                                   {{ sub.name }}
                              </v-list-item>
                         </v-list-item-content>
                    </v-list-item>
               </div>
          </v-list>
     </v-navigation-drawer>
</template>

<script>
export default {
     name: 'HomeDrawer',

     props: {
          items: {
               type: Array,
               default: () => [],
          },
     },
}
</script>
